import React, { useState, useContext } from "react";
import axiosClient from "../../config/axios";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import AttachmentOutlinedIcon from "@material-ui/icons/AttachmentOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import trashRedCircledIcon from "../../assets/icon/trashRedCircled.svg"
import AlertMui from "./AlertMui";

import AlertContext from "../../context/alert/alertContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "400px",
    },
  },
  input: {
    display: "none",
  },
}));

export default function FileUploadReceivers(props) {
  const alertContext = useContext(AlertContext);
  const { alert, showAlert } = alertContext;
  const { closeModal, type } = props;
  const [file, setFile] = useState(null);
  const [filename, setFileName] = useState(null);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [customerId,setCustomerId] = useState()
  const classes = useStyles();

  React.useEffect(()=>{ setCustomerId(JSON.parse(localStorage.getItem('customers'))[0].id)},[])
  const onChange = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const cleanFile = () => {
    setFile(null);
    setFileName(null);
  };

  const uploadFile = async (e) => {

    e.preventDefault();

    if (!file) {
      showAlert("El archivo es obligatorio", "warning");
      return;
    }
    setLoading(true);
    //pasar archivo a form data
    const data = new FormData();
    const fileData = file;
    data.append("file", fileData);
    data.append("CustomerId", customerId);
    data.append("Type", type);

    const typeFile ="/uploadreceiversfile"

    try {
      const response = await axiosClient({
        method: "POST",
        url: typeFile,
        data: data,
      });

      if (response.status === 200) {
        setLoading(false)
        //console.log('response ', response)
        const {data} =response
        if(data.status){
            if(data.status==='NOT_OK'){
                if(data.errors && data.errors.length && data.errors.length>=1){
                    showAlert(data.errors[0], "error");
                }
                else{
                    showAlert('Ocurrió un error, por favor reintente.', "error");
                }
            }else{
                showAlert(data.msg?data.msg:'Archivo cargado correctamente', "success");
                setTimeout(() => {
                    handleCloseModal();
                  }, 3000);
            }
        }
        else{
            showAlert('Ocurrió un error, por favor reintente.', "error");
        }
      }
    } catch (error) {
      if (error.response) {
          showAlert(error.response.status + " "+ error.response.data.msg, "error");
      }else{
        showAlert(JSON.stringify(error),"error")
      }
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    cleanFile();
    closeModal();
  };

  return (
    <div style={{ width: "550px" }}>
      <Box display="flex" p={1} bgcolor="background.paper">
        <Box p={1} width="100%" style={{ display: "flex" }}>
          <form style={{ width: "100%" }} onSubmit={uploadFile}>
            <input type='hidden' name="CustomerId" defaultValue={customerId} />
            <input type='hidden' name="Type" defaultValue={type} />
            <div style={{ width: "100%", display: "flex" , justifyContent:'left'}}>
             
              <label htmlFor="contained-button-file" style={{ margin: "auto" }}>
                <Button variant="contained" component="label" style={{backgroundColor:'#001070',color:'white',margin:'15px'}}
                >
                  Seleccionar archivo
                  <input
                      accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                      className={classes.input}
                      id="contained-button-file"
                      name="contained-button-file"
                      type="file"
                      onChange={onChange}
                      onClick={(event) => {
                      event.target.value = null;
                      }}
                    />
                </Button>
              </label>
              <Box
                p={1}
                flexShrink={0}
                style={{ width: "30px", margin: "auto" }}
              >
                <img src={trashRedCircledIcon} onClick={cleanFile} />
              </Box>
            </div>
            <Box
              p={1}
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              {filename && (
                <>
                  <AttachmentOutlinedIcon />
                  <p>{filename}</p>
                </>
              )}
            </Box>
          </form>
        </Box>
      </Box>
      {alert && <AlertMui message={alert.msg} type={alert.category} />}
      <Box style={{ float: "right" }}>
        {" "}
        {loading ? (
          <CircularProgress />
        ) : (
          <Button onClick={uploadFile}  variant="contained" style={{backgroundColor:'rgba(218, 41, 29, 0.86)',color:'white',margin:'15px'}}>
            ACEPTAR
          </Button>
        )}
        <Button onClick={handleCloseModal} variant="contained"  style={{backgroundColor:'#001070',color:'white',margin:'15px'}}>
          CANCELAR
        </Button>
      </Box>
    </div>
  );
}
